__turbopack_context__.v({
  "content": "Header-module-scss-module__uMrvSq__content",
  "header": "Header-module-scss-module__uMrvSq__header",
  "scrolled": "Header-module-scss-module__uMrvSq__scrolled",
});
